import { render, staticRenderFns } from "./ShowCall.vue?vue&type=template&id=fff4690a&scoped=true&"
import script from "./ShowCall.vue?vue&type=script&lang=js&"
export * from "./ShowCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff4690a",
  null
  
)

export default component.exports